import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isActiveButton: "true", //控制tabbar显示隐藏
    city: {
      cityName: "广州",
      cityId: "3278",
      day: "",
      Starttime: ""
    },
    invoice: {
      title: "不需要",
      id: ""
    },
    canUserCount: 0,
    isHotelStaff: "",
    remainingQuota: 0,
    mobilePhone: "",
    userName: "",
    type: null,
    editorinvoice: null,
    check_date: "",
    incheckname: ""
  },

  mutations: {
    getindexModel(state) {
      state.canUserCount = state.canUserCount;
      state.mobilePhone = state.mobilePhone;
      state.userName = state.userName;
      // state.isHotelStaff = state.isHotelStaff;
      state.remainingQuota = state.remainingQuota;
    }
  },
  actions: {}
});



// WEBPACK FOOTER //
// ./src/store/store.js